var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('InstructionModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}],attrs:{"copy":_vm.copy}}),_c('SignatureForm',{attrs:{"copy":_vm.copy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }